const menuTemplate = [
    {
        selector: '[data-menu-template]',
        path: { filename: 'menuTemplate' },
    },
];

export { menuTemplate };
